import React from 'react'
import Header from "../header/Header";
import SideBar from "../sidebar/SideBar";
import Table from '../Table';
import QuoteHeader from './QuoteHeader';
import DashboardLayout from '../layout';


const obj = {
    ative: true,
    content: "Quotes"
}

const index = () => {
    return (
        <>
            <DashboardLayout>
                {/* <div className="h-full sm:block hidden border-r  " >
                    <SideBar obj={obj} />
                </div> */}
                <div className="w-full" >
                    <Header title="Quotes" />

                    <div className='p-5 bg-[#eaeff6]'>
                        <QuoteHeader />
                        <Table headings={['#', 'User', 'Qoute Number', 'Date', 'Status', 'Amount', 'Action']} />
                    </div>
                </div>



            </DashboardLayout>
        </>
    )
}

export default index